// Copyright (c) 2025. CYBERKOALA LLC.
//
// SPDX-License-Identifier: Proprietary License.
//
// Redistribution and use in source and binary forms, with or without
// modification, are restricted.

import { createContext } from 'react';

export type UserStatus =
  | 'online'
  | 'away'
  | 'dnd'
  | 'invisible'
  | 'offline'
  | '😀'
  | '☹️'
  | '🎮'
  | '💡';

interface StatusContextType {
  status: UserStatus;
  description?: string;
  setStatus: (status: UserStatus) => void;
  setDescription: (description: string) => void;
  updatedAt: Date;
  setUpdatedAt: (date: Date) => void;
}

export const StatusContext = createContext<StatusContextType>({
  status: 'online',
  description: '',
  setStatus: () => {},
  setDescription: () => {},
  updatedAt: new Date(),
  setUpdatedAt: () => {},
});
